import { render, staticRenderFns } from "./msgRecord.vue?vue&type=template&id=3aae58e6&scoped=true&"
import script from "./msgRecord.vue?vue&type=script&lang=js&"
export * from "./msgRecord.vue?vue&type=script&lang=js&"
import style0 from "./msgRecord.vue?vue&type=style&index=0&id=3aae58e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae58e6",
  null
  
)

export default component.exports